import React from 'react'
import c from 'classnames'
import Currency from '../Currency'

const ReleaseMethodItem = ({
  description,
  handleSelect,
  handleOpenModal,
  isSelected,
  title,
  price
}) => {
  return (
    <div className="flex bg-white rounded-lg p-3.5 mb-3.5" onClick={handleSelect}>
      <div
        className={c(
          'w-5 h-5 border-2 rounded-full border-primary-light transition-all mr-3.5 flex-shrink-0',
          isSelected && 'border-8'
        )}
      />
      <div className="w-full">
        <div className="font-bold flex justify-between">
          <span>{title}</span>
          <span>
            <Currency amount={price} />
          </span>
        </div>
        <div className="text-sm whitespace-pre-line">{description}</div>
        <div className="text-right">
          <span
            className="font-bold text-sm text-green-800"
            onClick={handleOpenModal}
            role="button"
            tabIndex="0"
          >
            Learn more
          </span>
        </div>
      </div>
    </div>
  )
}

export default ReleaseMethodItem
